import React from 'react';
import { Row, Col, Panel, Dropdown, MenuItem } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { ProjectContactsPropTypes } from 'components/project/prop_types';
import UnstyledDropdownToggle from 'components/bootstrap_extensions/unstyled_dropdown_toggle';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faCircle, faUser, faBriefcase } from '@fortawesome/pro-solid-svg-icons';

export default class ContactPanelRow extends React.Component {
  static propTypes = {
    contact: ProjectContactsPropTypes,
    onCreateTask: PropTypes.func,
    onEditContact: PropTypes.func,
    onLogActivity: PropTypes.func,
    onRemoveContact: PropTypes.func
  };

  renderIcon(contact) {
    if (contact.type === 'company') {
      return (
        <span className='fa-stack fa-lg'>
          <FontAwesomeIcon className="details-icon fa-stack-2x" icon={faCircle} />
          <FontAwesomeIcon className="fa-stack-1x fa-inverse" icon={faBriefcase} />
        </span>
      );
    }
    if (contact.initials.length > 0) {
      return (
        <span className='initials-bubble fa-lg'>
          <div className='text'>
            { contact.initials }
          </div>
        </span>
      );
    }
    return (
      <span className='fa-stack fa-lg'>
        <FontAwesomeIcon className="details-icon fa-stack-2x" icon={faCircle} />
        <FontAwesomeIcon className="fa-stack-1x fa-inverse" icon={faUser} />
      </span>
    );
  }

  renderActions(contact) {
    const { onEditContact, onRemoveContact, onCreateTask, onLogActivity } = this.props;
    const anyActions = onEditContact || onRemoveContact || onCreateTask;

    if (!anyActions) return;

    return (
      <Col className="text-right" xs={2}>
        <Dropdown className="contact-options" id={`contacts-options-${contact.id}`}>
          <UnstyledDropdownToggle bsRole="toggle">
            <FontAwesomeIcon className="text-muted clickable" icon={faCog} size="lg" />
          </UnstyledDropdownToggle>
          <Dropdown.Menu className="dropdown-menu-right" >
            {onCreateTask &&
              <MenuItem
                eventKey="1"
                name={`create-contact-task-${contact.id}`}
                onClick={() => {
                  onCreateTask({
                    defaultTaskAssociation: {
                      associatedModelId: contact.contactId,
                      associatedModelType: contact.contactType,
                      default: true,
                      name: contact.name
                    }
                  });
                }}
              >
                New Task
              </MenuItem>
            }
            {onLogActivity &&
              <MenuItem
                eventKey="2"
                name={`log-contact-activity-${contact.id}`}
                onClick={() => {
                  onLogActivity({
                    defaultTaskAssociation: {
                      associatedModelId: contact.contactId,
                      associatedModelType: contact.contactType,
                      default: true,
                      name: contact.name
                    }
                  });
                }}
              >
                New Activity
              </MenuItem>
            }
            {onEditContact &&
              <MenuItem
                eventKey="3"
                name={`edit-contact-${contact.id}`}
                onClick={e => onEditContact(e, contact)}
              >
                Edit
              </MenuItem>
            }
            {onRemoveContact &&
              <MenuItem
                eventKey="4"
                name={`remove-contact-${contact.id}`}
                onClick={() => onRemoveContact(contact.id)}
              >
                Delete
              </MenuItem>
            }
          </Dropdown.Menu>
        </Dropdown>
      </Col>
    );
  }

  render() {
    const { contact } = this.props;

    let link = (
      <strong>
        { contact.name ? contact.name : contact.email }
      </strong>
    );

    if (contact.link) {
      link = (
        <a href={contact.link} name='contactLink' >
          {link}
        </a>
      );
    }

    return (
      <Panel.Body className='border-bottom' key={contact.id} name='contactRow'>
        <Row className='row-eq-height'>
          <Col xs={10}>
            <div className='text-muted'>{ contact.header }</div>
            <div className='details-item pt-1'>
              <div>
                { this.renderIcon(contact) }
              </div>
              <div className='pl-4'>
                { link }
                { contact.name &&
                  <div>{ contact.email }</div>
                }
                <div>{ contact.phone }</div>
                <div>{ contact.companyName }</div>
              </div>
            </div>
          </Col>
          {this.renderActions(contact)}
        </Row>
      </Panel.Body>
    );
  }
}
